<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>
        <div v-else>
          <CForm>
            <CRow>
              <CCol md="4">
                <CInput
                  label="Name"
                  invalid-feedback="Name should be filled"
                  required
                  v-model="$v.partnershipGroupForm.name.$model"
                  :is-valid="!$v.partnershipGroupForm.name.$invalid"
                  :readonly="isReadonly"
                />
              </CCol>
              
               <CCol md="4">
                  <div class="form-group">
                    <label for="flag">Show</label>
                    <model-select
                      class="form-control"
                      id="flag"
                      :options="showList"
                      v-model="$v.partnershipGroupForm.show.$model"
                      :isError="$v.partnershipGroupForm.show.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.partnershipGroupForm.show.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Show must be filled.
                    </div>
                  </div>
                </CCol>
            </CRow>

            <CRow>
              <CCol md="6">
                <label for="opening description">Opening Description</label>
                <quill-editor
                  style="height: 200px; margin-bottom: 70px"
                  :content="content"
                  :options="editorOption"
                  v-model="$v.partnershipGroupForm.opening_description.$model"
                  @change="onEditorChange($event)"
                  :disabled="isReadonly"
                >
                </quill-editor>
                <div
                  v-if="$v.partnershipGroupForm.opening_description.$invalid"
                  class="invalid-feedback-custom"
                >
                  Description harus di isi.
                </div>
              </CCol>
              <CCol md="6">
                <label for="Closing description">Closing Description</label>
                <quill-editor
                  style="height: 200px; margin-bottom: 70px"
                  :content="content2"
                  :options="editorOption2"
                  v-model="$v.partnershipGroupForm.closing_description.$model"
                  @change="onEditorChange2($event)"
                  :disabled="isReadonly"
                >
                </quill-editor>
                <div
                  v-if="$v.partnershipGroupForm.closing_description.$invalid"
                  class="invalid-feedback-custom"
                >
                  Closing Description harus di isi.
                </div>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              :disabled="$v.partnershipGroupForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Images</template>
            <UploadImage
              :partnership-group="partnershipGroupForm"
              :partnership-group-show="partnershipGroupShow"
            ></UploadImage>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";

import { required } from "vuelidate/lib/validators";
import UploadImage from "./tabs/UploadImage";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "PartnershipGroupDetail",
  components: { GlobalTable, Loading, UploadImage, quillEditor },
  data() {
    return {
      title: "Partnership Group Detail",
      partnershipGroupForm: tableInterfaces.partnership_group,
      isLoading: false,
      activeTab: 0,
      partnershipGroupShow: null,
      showList: [
        { value: "1", text: "Show" },
        { value: "0", text: "Not Show" },
      ],
      content: "",
      content2: "",
      editorOption: {},
      editorOption2: {}, // data quill
    };
  },
  validations: {
    partnershipGroupForm: {
      name: { required },
      opening_description: { required },
      closing_description: { required },
      show: {required}
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isReadonly: function () {
      return (this.partnershipGroupShow === '0' || this.partnershipGroupShow === null) ? false : true;
    },
  },
  methods: {
    init: function (id) {
      this.getPartnershipDetail(id);
    },
    getPartnershipDetail: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/partnership/group/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.partnershipGroupForm = response.data.data;
            this.partnershipGroupShow = this.partnershipGroupForm.show;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Partnership ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/partnership/group/update", this.partnershipGroupForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Partnership detail",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Partnership detail error");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.partnershipGroupForm.opening_description = html;
    },
      onEditorChange2({ quill, html, text }) {
      this.content2 = html;
      this.partnershipGroupForm.closing_description = html;
    },
  },
  
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
